import { ActionTypes } from '../constants/index';

export const getadminnotification = (payload: any) => ({
  type: ActionTypes.ADMIN_NOTIFICATION_MGMT_LIST_REQUEST,
  payload,
});
